import { render, staticRenderFns } from "./503.vue?vue&type=template&id=4c1a2afc"
import script from "./503.vue?vue&type=script&lang=js"
export * from "./503.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports